<template>
	<div>
		<div class="uk-container-expand blogScreen">
				<appNav></appNav>
		</div>



		<div class="uk-container blogScreen">
			<div class="uk-h3">{{ ms }}</div>
			<hr class="uk-divider-icon">


			<div id="item"></div>

			


			<div class="uk-grid-large" uk-grid>

					<div class="uk-width-auto rightBorder uk-visible@s">
							<div class="leftNavBar">
								<appOurShops></appOurShops>
							</div>
					</div>

					<div class="uk-width-expand">




					<div class="uk-grid-small" uk-grid v-for="blog in getBlogs" :key="blog.id" >

						<router-link tag="a" class=" uk-grid-small uk-card uk-card-small uk-card-default uk-card-hover uk-link-reset" :to="'/post/' + blog.id" uk-grid> 
							<div class="bgPicBlog uk-width-1-5@l uk-width-1-4@m uk-width-1-1@s uk-width-1-1">
									<div class="uk-background-cover uk-height-small uk-panel uk-flex uk-flex-center uk-flex-middle" :style="blog.picUrl">
							</div>
						</div>

						<div class="uk-width-expand">
							<div class="uk-card-body uk-card-small">
									<h3 class="uk-card-title">{{ blog.title }}</h3>
									<p>{{ blog.shortDescr }}</p>
							</div>
						</div>

						</router-link>

					</div>



<br>
<br>
<br>
<br>
<br>
<br>
						<hr>

							
					</div>
			</div>

<button  class="uk-margin uk-button uk-button-text " href="#item" uk-scroll> <i class="mdi mdi-chevron-up"></i>Наверх</button>

		<br>
		<br>
		<br>

		</div>
	</div>
</template>


<script>
import appNav from '@/components/Nav'
import appOurShops from '@/components/Ourshops'

/* eslint-disable no-console */
/* eslint-disable no-alert */

export default {
	data () {
		return {
			ms: 'Блог',
		}
	},
	methods: {
		toShop () {
			this.$router.push('/shops')
		}
	},
	computed: {
		getBlogs () {
			return this.$store.getters.getBlogs
		}
	},
	components: {
		appNav,
		appOurShops
	}
}
</script>




<style>
.blogScreen .uk-navbar-container:not(.uk-navbar-transparent) {
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.0001) 0%, #ecf0f1 150.79%);
}

.blogScreen .uk-navbar-nav>li>a {
	font-weight: 500;
}


.blogScreen .leftNavBar{
 width: 200px;
 padding-right: 5px;
 /* background-color: #ccc; */
}

.listBlog {
	margin-bottom: 20px;
}


.picBlog {
	width: 100%;
	max-width: 100%;
}


.bgPicBlog {
	background-color: #DE1F24;
	transition: ease .3s;
}


.blogScreen .uk-card {
	margin-bottom: 25px;
	transition: ease .3s;
}

.blogScreen .uk-card:hover .bgPicBlog{
	transform: translateX(5px);
}
</style>